export enum DeclineFeedback {
  DistanceTooFar = 'distance_too_far',
  SalaryTooLow = 'salary_too_low',
  AlreadyWorked = 'already_worked_for_this_organisation',
  DoNotWant = 'do_not_want_any_further_invitations',
  ShiftsImpossible = 'shifts_is_not_possible',
  FewCareerOpportunities = 'few_career_opportunities',
  NoMatchingQualifications = 'no_matching_qualifications',
  NotLookingForJob = 'not_looking_for_a_job',
  Others = 'others',
}

export const SAME_EMPLOYER_DECLINE_FEEDBACK = [DeclineFeedback.DoNotWant, DeclineFeedback.AlreadyWorked];
